import Loading from './Loading.component';

export default Loading;
